import axiosInstance from './axiosInstance';
import {
  ProjectDto,
  CreateProjectDto,
  UpdateProjectDto,
  ProjectStatisticsDto,
  ProjectMemberDto,
  AddProjectMemberDto,
  TaskItemDto,
  CreateTaskItemDto,
  UpdateTaskItemDto,
  MoveTaskDto,
  TaskCommentDto,
  CreateTaskCommentDto,
} from '../types/tasks';

export const taskService = {
  // Projects
  async createProject(dto: CreateProjectDto): Promise<ProjectDto> {
    const response = await axiosInstance.post<ProjectDto>('/api/projects', dto);
    return response.data;
  },

  async getMyProjects(): Promise<ProjectDto[]> {
    const response = await axiosInstance.get<ProjectDto[]>('/api/projects');
    return response.data;
  },

  async getProjectById(id: string): Promise<ProjectDto> {
    const response = await axiosInstance.get<ProjectDto>(`/api/projects/${id}`);
    return response.data;
  },

  async updateProject(id: string, dto: UpdateProjectDto): Promise<ProjectDto> {
    const response = await axiosInstance.put<ProjectDto>(`/api/projects/${id}`, dto);
    return response.data;
  },

  async deleteProject(id: string): Promise<void> {
    await axiosInstance.delete(`/api/projects/${id}`);
  },

  async getProjectStatistics(id: string): Promise<ProjectStatisticsDto> {
    const response = await axiosInstance.get<ProjectStatisticsDto>(`/api/projects/${id}/statistics`);
    return response.data;
  },

  async getProjectMembers(id: string): Promise<ProjectMemberDto[]> {
    const response = await axiosInstance.get<ProjectMemberDto[]>(`/api/projects/${id}/members`);
    return response.data;
  },

  async addProjectMember(id: string, dto: AddProjectMemberDto): Promise<ProjectMemberDto> {
    const response = await axiosInstance.post<ProjectMemberDto>(`/api/projects/${id}/members`, dto);
    return response.data;
  },

  async removeProjectMember(id: string, userId: string): Promise<void> {
    await axiosInstance.delete(`/api/projects/${id}/members/${userId}`);
  },

  // Tasks
  async createTask(projectId: string, dto: CreateTaskItemDto): Promise<TaskItemDto> {
    const response = await axiosInstance.post<TaskItemDto>(`/api/projects/${projectId}/tasks`, dto);
    return response.data;
  },

  async getProjectTasks(projectId: string, status?: string): Promise<TaskItemDto[]> {
    const response = await axiosInstance.get<TaskItemDto[]>(`/api/projects/${projectId}/tasks`, {
      params: status ? { status } : {},
    });
    return response.data;
  },

  async getMyTasks(status?: string): Promise<TaskItemDto[]> {
    const response = await axiosInstance.get<TaskItemDto[]>('/api/tasks/my', {
      params: status ? { status } : {},
    });
    return response.data;
  },

  async getTaskById(id: string): Promise<TaskItemDto> {
    const response = await axiosInstance.get<TaskItemDto>(`/api/tasks/${id}`);
    return response.data;
  },

  async updateTask(id: string, dto: UpdateTaskItemDto): Promise<TaskItemDto> {
    const response = await axiosInstance.put<TaskItemDto>(`/api/tasks/${id}`, dto);
    return response.data;
  },

  async moveTask(id: string, dto: MoveTaskDto): Promise<TaskItemDto> {
    const response = await axiosInstance.patch<TaskItemDto>(`/api/tasks/${id}/move`, dto);
    return response.data;
  },

  async deleteTask(id: string): Promise<void> {
    await axiosInstance.delete(`/api/tasks/${id}`);
  },

  // Comments
  async addComment(taskId: string, dto: CreateTaskCommentDto): Promise<TaskCommentDto> {
    const response = await axiosInstance.post<TaskCommentDto>(`/api/tasks/${taskId}/comments`, dto);
    return response.data;
  },

  async getComments(taskId: string): Promise<TaskCommentDto[]> {
    const response = await axiosInstance.get<TaskCommentDto[]>(`/api/tasks/${taskId}/comments`);
    return response.data;
  },

  async deleteComment(taskId: string, id: string): Promise<void> {
    await axiosInstance.delete(`/api/tasks/${taskId}/comments/${id}`);
  },
};
